<template>
  <v-navigation-drawer
    v-model="drawer"
    width="400"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }}</span>
    </div>

    <div class="pl-3 pt-3 pr-3" style="height: 80vh;">
      <template>
        <v-row>
          <v-col cols="12">
            <v-text-field
              ref="name"
              v-model="regimenForm.nombre"
              label="Nombre"
              outlined
              :rules="[
                () => !!regimenForm.nombre || 'Es necesario ingresar un nombre',
              ]"
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              ref="name"
              v-model="regimenForm.aporte_obligatorio"
              label="Aporte Obligatorio"
              outlined
              :rules="[
                () =>
                  !!regimenForm.aporte_obligatorio ||
                  'Es necesario ingresar un Aporte Obligatorio',
              ]"
              hide-details="auto"
              prefix="%"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              ref="name"
              v-model="regimenForm.prima_seguro"
              label="Prima Seguro"
              outlined
              :rules="[
                () =>
                  !!regimenForm.prima_seguro ||
                  'Es necesario ingresar un Prima Seguro',
              ]"
              hide-details="auto"
              prefix="%"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              ref="name"
              v-model="regimenForm.comision_porcentual"
              label="Comision Porcentual"
              outlined
              :rules="[
                () =>
                  !!regimenForm.comision_porcentual ||
                  'Es necesario ingresar un Comision Porcentual',
              ]"
              hide-details="auto"
              prefix="%"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn block height="40" dark color="red" @click="handleCancel">
              <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              v-if="action == 'create'"
              dark
              color="success"
              block
              height="40"
              @click="handleStore"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Guardar
            </v-btn>
            <v-btn
              v-if="action == 'update'"
              dark
              color="success"
              block
              height="40"
              @click="handleUpdate"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CreateUpdate",
  data() {
    return {
      drawer: false,
      titleForm: null,
      action: null,
      regimenForm: {
        id: null,
        nombre: null,
        aporte_obligatorio: null,
        prima_seguro: null,
        comision_porcentual: null,
        total_comision: null,
      },
    };
  },
  methods: {
    ...mapActions("regimenes", ["store", "update"]),
    async showForm(title, action, regimen = null) {
      await this.clearData();
      this.titleForm = title;
      this.action = action;
      if (regimen) {
        this.setRegimen(regimen);
      }
      this.drawer = !this.drawer;
    },
    clearData() {
      this.titleForm = null;
      this.action = null;
      //this.regimenForm = null;
      this.regimenForm.nombre = null;
      this.regimenForm.aporte_obligatorio = null;
      this.regimenForm.prima_seguro = null;
      this.regimenForm.comision_porcentual = null;
      this.regimenForm.total_comision = null;

      //this.clearErrors();
    },
    setRegimen(regimen) {
      this.regimenForm.id = regimen.id;
      this.regimenForm.nombre = regimen.nombre;
      this.regimenForm.aporte_obligatorio = regimen.aporte_obligatorio;
      this.regimenForm.prima_seguro = regimen.prima_seguro;
      this.regimenForm.comision_porcentual = regimen.comision_porcentual;
      this.regimenForm.total_comision = regimen.total_comision;
    },
    closeForm() {
      this.clearData();
      this.drawer = false;
    },
    handleCancel() {
      this.closeForm();
    },
    async handleStore() {
      // console.log()
      await this.store(this.regimenForm);
      this.closeForm();
      /*if (!this.existErrors()) {

            }*/
    },
    async handleUpdate() {
      await this.update(this.regimenForm);
      this.closeForm();
      /*if (!this.existErrors()) {
                await this.store(this.regimenForm);
                this.closeForm();
            }*/
    },
    /*existsErrors() {
            let hasErrors = false;

            object.keys(this.regimenForm).forEach(f => {
                if (this.$refs[f]) {
                    if (!this.regimenForm[f]) hasErrors = true
                        this.$refs[f].validate(true);
                }
            }); 
        },
        clearErrors() {
            Object.keys(this.brandForm).forEach(f => {
                if (this.$refs[f]) this.$refs[f].reset()                
            });
        },*/
  },
};
</script>

<style scoped></style>
